module.exports = {
  langs: ['de', 'en'],
  defaultLangKey: 'de',
};
